import { type HttpClient } from '../useHttpClient';

export type UnitInsightLlmChatsResponse = {
  data: {
    id: number;
    createdOn: string;
  }[];
};

export const getUnitInsightLlmChats =
  (httpClient: HttpClient) =>
  async ({
    unitId,
    insightId,
  }: {
    unitId: string | number;
    insightId: string | number;
  }) => {
    const res = await httpClient.api(
      `/kpis/unit/${unitId}/insights/llm/${insightId}/chats`
    );

    return res.json as UnitInsightLlmChatsResponse;
  };
